import React from 'react';
import { Link } from 'react-router-dom';

const WelcomePage = () => {
  return (
    <div className="welcome-page">
      <h1>Benvenuto nell'App Fidelity Card Creator</h1>
      <p>Questa app ti permetterà di creare carte fedeltà personalizzate per la tua attività in pochi semplici passaggi:</p>
      <ol>
        <li>Configura il profilo della tua attività</li>
        <li>Scegli o carica il layout della tua card</li>
        <li>Personalizza i dettagli della card</li>
        <li>Crea e gestisci le carte fedeltà per i tuoi clienti</li>
      </ol>
      <Link to="/setup/business-info" className="btn btn-primary">
        Inizia la configurazione
      </Link>
    </div>
  );
};

export default WelcomePage;